let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("31jpa")).then(() => parcelRequire('gLqyT'));